<script setup lang="ts"></script>

<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16667 15.4167C7.16667 16.5673 6.23393 17.5 5.08333 17.5C3.93274 17.5 3 16.5673 3 15.4167C3 14.2661 3.93274 13.3333 5.08333 13.3333M7.16667 15.4167C7.16667 14.2661 6.23393 13.3333 5.08333 13.3333M7.16667 15.4167H13.8333M5.08333 13.3333L5.91667 6.66667M5.91667 6.66667C4.76607 6.66667 3.83333 5.73393 3.83333 4.58333C3.83333 3.43274 4.76607 2.5 5.91667 2.5C7.06726 2.5 8 3.43274 8 4.58333M5.91667 6.66667C7.06726 6.66667 8 5.73393 8 4.58333M8 4.58333H13M15.0833 6.66667C13.9327 6.66667 13 5.73393 13 4.58333M15.0833 6.66667C16.2339 6.66667 17.1667 5.73393 17.1667 4.58333C17.1667 3.43274 16.2339 2.5 15.0833 2.5C13.9327 2.5 13 3.43274 13 4.58333M15.0833 6.66667L15.9167 13.3333M13.8333 15.4167C13.8333 16.5673 14.7661 17.5 15.9167 17.5C17.0673 17.5 18 16.5673 18 15.4167C18 14.2661 17.0673 13.3333 15.9167 13.3333M13.8333 15.4167C13.8333 14.2661 14.7661 13.3333 15.9167 13.3333"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>

<style scoped></style>
